<template>
  <div class="container" ref="myElement">
    <div ref="content">
        <div class="top"></div>
      <img class="slogan" src="@/assets/img/slogan.png" alt="">
      <div class="canter" :style="{'margin-bottom':floatBottom?'80px':'0px'}">
        <div class="card">
          <img v-if="hoverOne" src="@/assets/img/bg1.png" alt="背景" class="card-bg" style="right:0;"/>
          <img v-else src="@/assets/img/bg2.png" alt="背景" class="card-bg" style="right:0;"/>
          <a
            href="http://sys.ssesse.cn/ssow/"
            target="_blank"
            rel="noopener noreferrer"
            @mouseenter="hoverOne = false"
            @mouseleave="hoverOne = true"
          >
          <div class="card-content">
            <div class="pointer">
              <img src="@/assets/img/logo1.png" alt="Logo" class="card-logo" />
            </div>
            <div class="pointer">
              <img src="@/assets/img/text1.png" alt="产品介绍" class="card-text" />
            </div>
            <div class="pointer">
              <img src="@/assets/img/icon5.png" alt="图标" class="card-icon" />
            </div>
            <div class="pointer">
              <img @mouseenter="hoverThree = true" @mousemove="handleMouseMove"
              @mouseleave="hoverThree = false" src="@/assets/img/qr1.jpg" alt="二维码" class="card-qr" ref="mouseTracker"/>
              <img v-if="hoverThree" class="bigPicture" :style="{left:ssX+'px',top:ssy+'px'}"  src="@/assets/img/msyy.png" alt="二维码" />
            </div>
            <p class="card-tip">扫码了解更多</p>
          </div>
          </a>
        </div>
        <div class="card">
          <img v-if="hoverTwo" src="@/assets/img/bg1.png" alt="背景" class="card-bg" style="left:0;"/>
          <img v-else src="@/assets/img/bg2.png" alt="背景" class="card-bg" style="left:0;"/>
          <a
            href="http://www.msyymsyy.com/index"
            target="_blank"
            rel="noopener noreferrer"
            @mouseenter="hoverTwo = false"
            @mouseleave="hoverTwo = true"
          >
            <div class="card-content">
              <div class="pointer"><img src="@/assets/img/logo2.png" alt="Logo" class="card-logo" /></div>
              <div class="pointer"><img src="@/assets/img/text2.png" alt="产品介绍" class="card-text" /></div>
              <div class="pointer"><img src="@/assets/img/icon6.png" alt="图标" class="card-icon" /></div>
              <div class="pointer">
                <img @mouseenter="hoverFour = true" @mousemove="handleMouseMove"
                @mouseleave="hoverFour = false" src="@/assets/img/qr2.png" alt="二维码" class="card-qr" />
                <img v-if="hoverFour" class="bigPicture" :style="{left:ssX+'px',top:ssy+'px'}"  src="@/assets/img/msyy.jpg" alt="二维码" />
            </div>
              <p class="card-tip">扫码了解更多</p>
            </div>
          </a>
        </div>
      </div>
      <footer class="footer" :class="[floatBottom?'fixed':'']">
        <div class="footer-divider"></div>
        <div class="footer-content">
          <div>
            <p>©2006-2026北京探感科技股份有限公司 地址：北京市海淀区东小府2号（中国林业科学研究院）</p>
            <p>ICP备案序号:京ICP备07500842号-1 京公海网安备110108002706号</p>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
    name: 'homePage',
    data() {
			return {
        hoverOne:true,
				hoverTwo: true,
        floatBottom:false,
        hoverThree:false,
        hoverFour:false,
        msyyX:0,
        msyyy:0
			}
		},
    mounted() {
      window.addEventListener('resize', this.setHeight);
      const element = this.$refs.mouseTracker;
      element.addEventListener('mousemove', this.handleMouseMove);
    },
    methods: {
      setHeight(){
        this.$nextTick(() => {
          if(this.$refs.myElement.offsetHeight<this.$refs.content.offsetHeight){
            this.floatBottom=false
          }else{
            this.floatBottom=true
          }
        })
      },
      handleMouseMove(){
        this.$nextTick(()=>{
          this.ssX = event.clientX-110; // 鼠标相对于视口的水平坐标
          this.ssy = event.clientY-250; // 鼠标相对于视口的垂直坐标
          this.$forceUpdate()
        })
      },
      handleMouseMoveMsyy(e) {
        this.msyyX = event.clientX; // 鼠标相对于视口的水平坐标
        this.msyyy = event.clientY; // 鼠标相对于视口的垂直坐标
      }
    },
     beforeUnmount() {
      // 组件销毁前移除事件监听器
      const element = this.$refs.mouseTracker;
      element.removeEventListener('mousemove', this.handleMouseMove);
    },
}
</script>

<style scoped>
.container{
  min-height:100vh;
  min-width:min-content;
  text-align: center;
  background: url(../assets/img/bg.png);
  background-size: cover; /* 或使用 contain */
  background-position: center; /* 确保图片居中 */
  background-repeat: no-repeat; /* 防止图片重复 */
}
.top{
  height:35px;
}
.slogan{
  display: block;
  width:450px;
  margin:0px auto;
}
.canter{
  display: flex;
  justify-content: center;
  margin:10px auto 0;
  width:calc(100% - 60px);
  height:400px;
  overflow: hidden;
}
.card{
  flex:1;
  /* position: relative; */
  margin-bottom:15px;
}
.card-bg {
  height:100%;
  pointer-events: none;
}
.mask{
  position: absolute;
  width:80%;
  height:90%;
  top:30px;
  left:10%;
}
.card-content {
  width:80%;
  margin:-360px 10% 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  z-index: 2;
}
.card-logo {
  width: 140px;
  height: auto;
}
.card-text {
  width: 300px;
  height: auto;
  margin:12px 0 8px;
}
.card-icon {
  width: 150px;
  height: auto;
}
.card-qr {
  width: 42px;
  height: auto;
  margin:8px 0 5px;
}
.card-tip {
  font-size: 12px;
  color: #ffffff;
  margin-top: 6px;
}
.footer{
  font-size: 12px;
  height:80px;
  line-height: 20px;
  color: #999999;
  background: #162F48;
}
.footer-divider {
  height: 1px;
  width: 100%;
  background: linear-gradient(to right, #102539 0%, #102539 20%, #8097ab 50%, #102539 80%, #102539 100%);
}
.footer-content {
  height:80px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.fixed{
  position: fixed;
  width:100%;
  bottom:0;
}
.bigPicture{
  position: absolute;
  /* top:-208px;
  left:calc(50% - 110px); */
  width:220px;
  z-index: 10;
  border:1px solid #0b3b69;
}


@media (min-width: 1024px) {
  .top{
    height:40px;
  }
  .slogan{
    width:500px;
  }
  .canter{
    width:calc(100% - 82px);
    height:440px;
  }
  .mask{
    top:30px;
  }
  .card-content {
    margin:-395px 10% 0;
  }
  .card{
    margin-bottom:15px;
  }
  .card-logo {
    width: 160px;
  }
  .card-text {
    width: 320px;
    margin:15px 0 10px;
  }
  .card-icon {
    width: 186.6px;
  }
  .card-qr {
    width: 43px;
    margin:10px 0 5px;
  }
}
@media (min-width: 1366px) {
  .top{
    height:52px;
  }
  .slogan{
    width:698px;
  }
  .canter{
    width:calc(100% - 108px);
    height:570px;
  }
  .mask{
    top:40px;
  }
  .card-content {
    margin:-515px 10% 0;
  }
  .card-logo {
    width: auto;
    height: 100px;
  }
  .card-text {
    width: 410px;
    margin:20px 0 14px;
  }
  .card-icon {
    width:auto;
    height:45px;
  }
  .card-qr {
    width: 57px;
    margin:15px 0 5px;
  }
}
@media (min-width: 1440px) {
  .top{
    height:56px;
  }
  .slogan{
    width:735px;
  }
  .canter{
    width:calc(100% - 122px);
    height:610px;
  }
  .mask{
    top:40px;
  }
  .card-content {
     margin:-540px 10% 0;
  }
  .card{
    /* margin-bottom:25px; */
  }
  .card-logo{
    padding-top: 10px;
    width:250px;
  }
  .card-text{
    width: 430px;
    margin:20px 0 15px;
  }
   .card-icon {
    width: 210px;
  }
  .card-qr {
    width: 61px;
    margin:15px 0 8px;
  }
  .card-tip {
    font-size: 14px;
  }
  .footer{
    height:90px;
    font-size: 14px;
    line-height: 22px;
  }
  .footer-content {
    height:90px;
  }
}
@media (min-width: 1680px) { /*0.95 */
  .canter{
    width:calc(100% - 140px);
    height:672px;
  }
  .mask{
    top:40px;
  }
  .card-content {
    margin:-590px 10% 0;
  }
  .card{
    margin-bottom:25px;
  }
  .card-logo {
    width: 260px;
  }
  .card-text {
    width: 440px;
    margin:30px 0 25px;
  }
  .card-icon {
    width: 230px;
  }
  .card-qr {
    width: 72px;
    margin:13px 0 5px;
  }
}
@media (min-width: 1920px) {
  .top{
    height:78px;
  }
  .slogan{
    width:981px;
  }
  .canter{
    width:calc(100% - 152px);
    height:790px;
  }
  .card{
    margin-bottom:30px;
  }
  .mask{
    top:50px;
  }
  .card-content {
    width:74%;
    margin:-710px 13% 0;
  }
  .card-logo {
    width: auto;
    height:135px;
  }
  .card-text {    /* 535 */
    width: auto;
    height:227px;
    margin:20px 0 15px;
  }
  .card-icon {
    width: auto;
  }
  .card-qr {
    width: auto;
    margin:20px 0 15px;
  }
  .card-tip {
    font-size: 16px;
    margin-top: 10px;
  }
  .footer{
    height:100px;
    font-size: 14px;
    line-height: 24px;
  }
  .footer-content {
    height:100px;
  }
}
.pointer{
  width:100%;
  cursor: pointer;
}
a{
text-decoration: none;}
</style>
